import {inject, Injectable} from "@angular/core";
import {AssetSampleApiClient} from "src/app/infrastructure/moovement-api/web-api/asset-sample.api-client";
import {AggregatedAssetState} from "src/app/domain/assets/aggregated-state/aggregated-asset-state";
import {oneYear, sevenDays} from "src/app/presentation/common/globals";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {NfcLocationMetadataStore, NfcLocationStore} from "src/app/domain/samples/nfc-location/nfc-location.store";
import {
  InternalNotificationsStore,
  InternalNotificationType
} from "src/app/infrastructure/internal-notifications/internal-notifications.store";
import {ascendingAssetSamples} from "src/app/app.config";
import {
  NfcLocationMetadataApiClient
} from "src/app/infrastructure/moovement-api/web-api/nfc-location-metadata.api-client";

@Injectable({
  providedIn: 'root'
})
export class NfcLocationService {

  private internalNotificationsStore = inject(InternalNotificationsStore);
  private nfcLocationStore = inject(NfcLocationStore);
  private nfcLocationMetadataStore = inject(NfcLocationMetadataStore);
  private nfcLocationMetadataApiClient = inject(NfcLocationMetadataApiClient);

  constructor(
    private assetSampleApiClient: AssetSampleApiClient
  ) {}

  loadLocations(id: string, state?: AggregatedAssetState) {
    if (this.nfcLocationStore.assetId() === id) return;

    this.nfcLocationStore.setAssetId(id);
    const lastNfcGpsFixAt = state?.lastNfcGpsFixAt;
    const to = lastNfcGpsFixAt !== undefined ? new Date(lastNfcGpsFixAt.getTime() + 1000) : new Date();
    const since = new Date(to.getTime() - oneYear);
    this.nfcLocationMetadataApiClient.getMetadata().subscribe({
      next: metadata => {
        this.nfcLocationMetadataStore.setMetadata(metadata);
      }
    })
    this.assetSampleApiClient.getAllAssetSamples<Samples.NfcGpsFix>('NfcLocation', [id]).subscribe({
      next: samples => {
        const sortedAssetSamples = samples
          .sort(ascendingAssetSamples());
        this.nfcLocationStore.setLocationSamples(sortedAssetSamples);
      },
      error: () => {
        this.nfcLocationStore.setAssetId(undefined);
        this.internalNotificationsStore.addNotification("Unable to retrieve locations.", InternalNotificationType.ERROR, false);
      }
    })
  }
}
